import { Component, OnInit, inject } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { IconService } from './services/icon.service';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

registerLocaleData(localeNl, 'nl');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private oauthService = inject(OAuthService);
  private iconService = inject(IconService);

  title = 'Handelingsperspectief';

  constructor() {
    const config = new AuthConfig();
    config.issuer = environment.issuer;
    config.redirectUri = environment.redirectUri;
    config.clientId = environment.clientId;
    config.requireHttps = false;
    config.postLogoutRedirectUri = environment.logoutUri;
    config.customQueryParams = { 'locale': 'nl' }
    this.oauthService.configure(config);
    this.oauthService.loadDiscoveryDocument(environment.connectId);
  }

  ngOnInit(): void {
    this.iconService.initCustomIcons();
  }
}
